window.fbAsyncInit = function() {
    FB.init({
      appId      : '1588003457929939',
      xfbml      : true,
      version    : 'v2.12'
    });
};
// 1588003457929939
// 774239726084069

(function(d, s, id){
   var js, fjs = d.getElementsByTagName(s)[0];
   if (d.getElementById(id)) {return;}
   js = d.createElement(s); js.id = id;
   js.src = "https://connect.facebook.net/zh_TW/sdk.js";
   fjs.parentNode.insertBefore(js, fjs);
 }(document, 'script', 'facebook-jssdk'));